import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateAccountStatus } from '../api/updateAccountStatus';
import { accountsKeys } from './useAccounts';

/**
 * Activates an account, then invalidates the shared accounts cache so the row re-reads
 * its state from the server rather than being patched locally. accountsKeys.list backs
 * both useAccounts and useClientCompanies.
 */
export const useActivateAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (accountId: number) => updateAccountStatus(accountId, true),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: accountsKeys.list });
    },
  });
};
